export default "__VITE_ASSET__DUn9KSlW__"